module.exports = __webpack_public_path__ + "static/unnamed-3--43a8649e7752ff799f5b3022b4788d77.png";